import { readable } from 'svelte/store';
export const isDebugMode = readable(!!process.env.DEBUG_MODE, undefined);
